// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"ex-z","smallCardRow":"fx-z","largeCardRow":"gx-z","productSearchRow":"hx-z","curatedRow":"ix-z"};